"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardInputSystem = void 0;
const Constants_1 = require("../../../Shared/Constants");
const gotti_1 = require("gotti");
const defaultInput = { mouseX: 0, mouseY: 0, mouseDown: false, aimAngle: 0, moveUp: false, moveDown: false, moveLeft: false, moveRight: false, pickup: false, grab: false };
class KeyboardInputSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.INPUT);
        this.registeredInput = false;
        this.trackedHotkeyIndexes = [];
        this.hotkeyArray = ['Digit1', 'Digit2', 'Digit3', 'Digit4'];
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
    }
    onServerMessage(message) { }
    onPeerMessage(peerId, message) { }
    onLocalMessage(message) { }
    iterateInput(input) {
        const { state, changed } = input;
        for (let key in state) {
            if (state[key] && !this.clientInputComponent.playerInput[key]) {
                this.clientInputComponent.playerInput[key] = state[key];
            }
        }
    }
    resetState() {
        ['moveDown', 'moveUp', 'moveLeft', 'moveRight', 'inventory', 'grab', 'pickup', 'cancel', 'pause'].forEach(k => {
            this.clientInputComponent.playerInput[k] = false;
        });
    }
    update(delta) {
        if (this.gameInput && this.clientInputComponent) {
            this.resetState();
            const { controller, keyboard } = this.gameInput.update();
            keyboard && this.iterateInput(keyboard);
            (controller && controller[0]) && this.iterateInput(controller[0]);
        }
    }
    onClear() { throw new Error("Method not implemented."); }
    onInit() {
        this.gameInput = this.globals.gameInput;
    }
    handleMouseMove(event) {
        this.clientInputComponent.playerInput.mouseX = event.clientX;
        this.clientInputComponent.playerInput.mouseY = event.clientY;
    }
    handleMouseDown(event) {
        this.clientInputComponent.playerInput.mouseDown = true;
    }
    handleMouseUp(event) {
        this.clientInputComponent.playerInput.mouseDown = false;
    }
    onEntityRemovedComponent(entity, component) {
        this.removeListeners();
    }
    removeListeners() {
    }
    onEntityAddedComponent(entity, component) {
        this.clientInputComponent = component;
        this.registerInputs();
    }
    registerInputs() {
        if (this.registeredInput)
            throw new Error(`Already registered input.`);
        let emitter;
        if (typeof document !== 'undefined' && document !== null) {
            emitter = document;
        }
        else if (typeof window !== 'undefined' && window !== null) {
            emitter = window;
        }
        emitter.addEventListener('mousemove', this.handleMouseMove);
        emitter.addEventListener('mousedown', this.handleMouseDown);
        emitter.addEventListener('mouseup', this.handleMouseUp);
    }
}
exports.KeyboardInputSystem = KeyboardInputSystem;
//# sourceMappingURL=module.js.map